import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'
import {
  colorWhite,
  colorWhiteAlpha85,
  elevatedSurfaceBoxShadow,
  transition,
} from '../../../../shared/style-settings'

export const useProfileComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      width: theme.spacing(18),
      height: theme.spacing(18),
      border: `4px solid ${theme.palette.primary.main}`,
      boxShadow: elevatedSurfaceBoxShadow,
      transition: transition,
    },
    fileInput: {
      display: 'none',
    },
    labelFileInput: {
      position: 'relative',
      display: 'inline-block',
      overflow: 'hidden',
      borderRadius: '50%',
      cursor: 'pointer',
      marginBottom: theme.spacing(4),
      transition: transition,
      '&:hover': {
        transform: 'scale(1.05)',
      },
      '&:hover $avatar': {
        boxShadow: elevatedSurfaceBoxShadow,
      },
    },
    avatarHolder: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(3),
    },
    removeHolder: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      right: 0,
      width: 32,
      height: 32,
      borderRadius: '50%',
      backgroundColor: theme.palette.error.main,
      color: colorWhite,
      transition: transition,
      boxShadow: elevatedSurfaceBoxShadow,
      zIndex: 10,
      '&:hover': {
        backgroundColor: theme.palette.error.dark,
        transform: 'scale(1.1)',
      },
      '& .MuiSvgIcon-root': {
        color: colorWhite,
        fontSize: '1.25rem',
      },
    },
    choosingBlock: {
      position: 'absolute',
      top: '60%',
      paddingTop: theme.spacing(1),
      left: 0,
      width: '100%',
      background: colorWhiteAlpha85,
      backdropFilter: 'blur(4px)',
      height: '100%',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
        fontSize: '1.5rem',
      },
    },
    textItem: {
      marginBottom: theme.spacing(2.5),
      '& .MuiOutlinedInput-root': {
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
          },
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 2,
          },
        },
      },
    },
    submit: {
      margin: theme.spacing(2, 0),
      display: 'inline-block',
      borderRadius: theme.shape.borderRadius * 2,
      padding: theme.spacing(1.5, 4),
      fontWeight: 600,
      fontSize: '0.9375rem',
      textTransform: 'none',
    },
  })
)
